import React from "react";

import { FaLinkedinIn, FaGithub, FaTwitterSquare } from "react-icons/fa";

export default [
  {
    icon: <FaLinkedinIn />,
    url: "https://www.linkedin.com/in/igor-hristov/",
  },
  {
    icon: <FaGithub />,
    url: "https://github.com/igorhristov",
  },
  {
    icon: <FaTwitterSquare />,
    url: "https://twitter.com/Igor_Hristov_",
  },
];
